 import { defineMessages } from 'react-intl';

export default defineMessages({
    tooltipDummy: {
        id: 'custom.products.CR.tooltip.Dummy',
        defaultMessage: 'Dummy'
    },
    
})